<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white p-10 rounded-2xl shadow-lg text-center">
      <h1 class="text-2xl font-bold text-green-600 mb-4">Thank You!</h1>
      <p class="text-gray-700">Your registration has been completed.</p>
    </div>
  </div>
</template>
